import '@angular/localize/init';

/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/** *************************************************************************************************
* BROWSER POLYFILLS
*
* Angular 20 targets evergreen browsers only (IE support was dropped). The former
* IE/legacy-Firefox polyfills (`classlist.js`, `web-animations-js`) and the
* `core-js/es/array` shim (for the removed ngx-charts) have been dropped — the
* Web Animations API and modern Array/Reflect built-ins are native everywhere
* Angular 20 supports. See performance-baseline-v20.md §5.
*/


/** `Reflect` metadata used by Angular's DI. Native in all supported browsers. */
import 'core-js/es/reflect';



/** *************************************************************************************************
 * Zone JS is required by Angular itself. It is loaded via the `polyfills` array
 * in angular.json (before this file) so the unit-test builder can inject
 * `zone.js/testing` alongside it for the test build.
 */



/** *************************************************************************************************
 * APPLICATION IMPORTS
 */

(window as any).global = window;
